// Centralised French language file for UI text in Weather App
// Please keep keys in sync with en.ts for consistency

const fr = {
  app: {
    title: 'WeatherUp!',
    welcome: 'Bienvenue sur WeatherUp! 🌤️',
    subtitle: 'Météo Mondiale',
    instructions: 'Entrez le nom d\'une ville pour vérifier la météo et rester informé des conditions actuelles. Commencez en tapant dans la boîte de recherche ci-dessus. Bonne exploration!'
  },
  weather: {
    loading: 'Chargement des données météo...',
    cardTitle: 'Météo pour',
    currentTemp: 'Température Actuelle',
    min: 'Min :',
    max: 'Max :',
    localTime: 'Heure Locale',
    details: 'Détails Météo',
    humidity: 'Humidité',
    pressure: 'Pression',
    windSpeed: 'Vitesse du vent',
    visibility: 'Visibilité',
    feelsLike: 'Ressentie',
  },
  search: {
    placeholder: 'Rechercher une ville...',
    ariaLabel: 'Rechercher une ville',
    button: 'Rechercher',
    noResults: 'Aucun lieu trouvé.'
  }
};

export default fr;
